// react
import React, { useContext, useMemo } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import { TextField, Checkbox, FormHelperText, CircularProgress } from '@material-ui/core';
import { Dialog, DialogContent, DialogTitle, Slide } from '@material-ui/core';
import Alert from '@mui/material/Alert';
import FileCopy from "@material-ui/icons/FileCopy";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

// services
import { MaskMoney, transformValueFormatedtoFloat, formateDate, MaskCel, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { SessionContext, getLanguageSelected } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";

const useStyles = makeStyles({
    ...styles,
    custonButton: {
        backgroundColor: '#60bf18',
        '&:hover': {
            backgroundColor: '#4c9813',
        },
        '&:focus': {
            backgroundColor: '#60bf18',
        },
        '&:active': {
            backgroundColor: '#60bf18',
        },
    },
});

export default function PagamentoLinkPagamento({ pgto, CallloadTotalizadorPgtos, clienteId }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, errors, handleSubmit, setValue } = useForm({ mode: "onBlur" });

    const endPointLinkPagamento = "beaktPaymentLinkPagamento/";

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 5000);
    };

    const [LoadingForm, setLoadingForm] = React.useState(false);
    const [exibeLinkPagamento, setExibeLinkPagamento] = React.useState(false);
    const [dadosLink, setDadosLink] = React.useState(null);
    const [valorSolicitado, setValorSolicitado] = React.useState(0);
    const [timeElapsed, setTimeElapsed] = React.useState(120000);
    const [exiteLinkPagamento, setExisteLinkPagamento] = React.useState(false);

    const onSubmit = (data, e) => {
        e.preventDefault();
        setLoadingForm(true);
        let valor = transformValueFormatedtoFloat(data.valor);

        if (valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2)) {
            showNotification(t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay'), 'warning');
            setLoadingForm(false);
            return false;
        }

        let requestGerarLink = {
            EstabelecimentoId: session.estabelecimentoId,
            ClienteId: clienteId,
            Valor: valor
        };

        setValorSolicitado(valor);

        UsePostApi(endPointLinkPagamento + 'gerarLinkPagamento', requestGerarLink).then(result => {
            if (result.status !== 200) {
                const errorMsg = (typeof result.message === 'object') ? result.message.message : result.message;
                showNotification(errorMsg || 'Erro ao processar requisição', 'error');
                setLoadingForm(false);
                return false;
            }

            const success = result.data?.sucesso ?? result.data?.Sucesso;
            if (result.data && !success) {
                showNotification(result.data.mensagem || result.data.Mensagem || 'Falha ao gerar link', 'error');
                setLoadingForm(false);
                return false;
            }

            setDadosLink(result.data);
            setExibeLinkPagamento(true);
            setLoadingForm(false);
            showNotification('Link de pagamento gerado com sucesso.', 'success');
            return true;
        });
    };

    const handleGetStatusLink = () => {
        let hashPedido = (dadosLink?.hashPedido || dadosLink?.HashPedido);

        if (!hashPedido) {
            showNotification('Hash do pedido não encontrado.', 'warning');
            return;
        }
        
        UseGetApiSimple(endPointLinkPagamento + "getStatusLinkPagamento/" + hashPedido).then(result => {
            if (result.status !== 200) {
                const errorMsg = (typeof result.message === 'object') ? result.message.message : result.message;
                showNotification(errorMsg || 'Erro ao consultar status do link', 'error');
                return;
            }
            else {
                const data = result.data;
                const status = data?.status || data?.Status;

                if (status === 'PENDENTE') {
                    showNotification('O pagamento ainda está pendente.', 'info');
                }
                else if (status === 'CANCELADO') {
                    showNotification('O link de pagamento foi cancelado.', 'warning');
                    handleGerarOutroLink();
                }
                else if (status === 'PAGO') {
                    const retornos = data?.vendaPagamentoLinkPagamentoRetorno || [];
                    let valor = retornos.reduce((acc, curr) => acc + (curr.valor || 0), 0);
                    let maxParcelas = retornos.length > 0 ? Math.max(...retornos.map(r => r.parcelas || 1)) : 1;

                    if (valor > 0) {
                        let pg = {
                            id: pgto.pagamentos.length + 1,
                            tipo: 6, // 0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros / 5-PIX / 6-Link de Pagamento
                            descricaoFormaPgto: 'Link de Pagamento (Carat)',
                            valor: valor,
                            descTipo: 'Link de Pagamento (Carat)',
                            parcela: maxParcelas,
                            descPacela: maxParcelas > 1 ? t('label.parceled') : t('label.at_sight'),
                            hashPedido: data?.hashPedido || hashPedido,
                            bloqueado: true,
                        }

                        let updatepgto = {
                            ...pgto,
                            pagamentos: [
                                ...pgto.pagamentos,
                                pg
                            ]
                        }

                        setTimeElapsed(240000);
                        handleLimparVariaveis();
                        CallloadTotalizadorPgtos(updatepgto);
                        setLoadingForm(false);
                        showNotification('Pago com sucesso, prossiga com a finalização da venda.', 'success');
                        return true;
                    } else {
                        showNotification('O valor do pagamento está zerado.', 'warning');
                        setLoadingForm(false);
                        return false;
                    }
                }
            }
        });
    };

    const handleLimparVariaveis = () => {
        setExibeLinkPagamento(false);
        setDadosLink(null);
        setValue("valor", "");
    };

    const handleGerarOutroLink = () => {
        handleGetStatusLink();
        handleLimparVariaveis();
    };

    const handleLancarPagamento = () => {
        let hashPedido =  (dadosLink?.hashPedido || dadosLink?.HashPedido);

        let pg = {
            id: pgto.pagamentos.length + 1,
            tipo: 6, // 6-Link de Pagamento
            descricaoFormaPgto: 'Link de Pagamento (Carat)',
            valor: valorSolicitado,
            descTipo: 'Link de Pagamento',
            parcela: 1,
            descPacela: t('label.at_sight'),
            hashPedido: hashPedido,
            bloqueado: false,
        }

        let updatepgto = {
            ...pgto,
            pagamentos: [
                ...pgto.pagamentos,
                pg
            ]
        }

        handleGerarOutroLink();
        CallloadTotalizadorPgtos(updatepgto);
        showNotification('Pagamento lançado. A confirmação será feita posteriormente.', 'success');
    };

    const handleCopyLink = () => {
        const url = dadosLink?.urlPagamento || dadosLink?.UrlPagamento;
        if (!url) return;

        navigator.clipboard.writeText(url)
            .then(() => {
                showNotification('Link copiado com sucesso.', 'success');
            })
            .catch(err => {
                showNotification('Erro ao copiar o link: ' + err, 'error');
            });
    };
    
    const habilitaGerarLinkPagamento = useMemo(() => {
        if (!pgto?.pagamentos) return true;
        
        const existeBloqueio = pgto.pagamentos.some(p =>
            p.descricaoFormaPgto === 'Link de Pagamento (Carat)' ||
            p.descricaoFormaPgto === 'PIX Integrado' ||
            p.descricaoFormaPgto === 'Dr Sim' ||
            p.tipo === 1
        );

        const existeLinkDePagamento = pgto.pagamentos.some(
            p => p.descricaoFormaPgto === 'Link de Pagamento (Carat)'
        );
        setExisteLinkPagamento(existeLinkDePagamento);

        return !existeBloqueio;
    }, [pgto?.pagamentos]);
    
    return (
        <div style={{ width: '95%' }}>
            {
                notification.show &&
                <Alert icon={false} severity={notification.color}>
                    {notification.message}
                </Alert>
            }
            {
                exibeLinkPagamento ?
                    (
                        <div style={{ textAlign: 'center', padding: '20px 0' }}>
                            <hr style={{ margin: '5px 0 30px' }} />
                            <GridContainer style={{ alignItems: 'center', textAlign: 'center' }}>
                                <GridItem xs={12}>
                                    <h3 style={{ color: '#6c757d' }}>
                                        Utilize o link abaixo para o cliente realizar o pagamento do valor de
                                        <span style={{ fontWeight: 'bold' }}> R$ {transformValueFloattoFormated(valorSolicitado)}</span>
                                    </h3>
                                </GridItem>
                                <GridItem xs={12} style={{ marginTop: '20px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                                        <a
                                            href={dadosLink?.urlPagamento || dadosLink?.UrlPagamento}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                fontSize: '1.8rem',
                                                color: '#00305c',
                                                fontWeight: 'bold',
                                                textDecoration: 'underline'
                                            }}
                                        >
                                            Link de Pagamento
                                        </a>
                                        <FileCopy
                                            onClick={handleCopyLink}
                                            style={{ cursor: 'pointer', color: '#00305c', fontSize: '1.8rem' }}
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr style={{ margin: '30px 0 5px' }} />
                            <GridContainer spacing={2} justify="center">
                                <GridItem xs={12} sm={12} md={12}>
                                    <span style={{ color: '#00305c', fontWeight: 'bold' }}>
                                        Aguarde o pagamento no link para prosseguir com a finalização da venda clicando em
                                        "CONSULTAR STATUS", ou prossiga sem a confirmação imediata através do botão
                                        "LANÇAR PAGAMENTO" (a confirmação será feita na tela Vendas em Andamento).
                                    </span>
                                </GridItem>
                            </GridContainer>
                            <hr style={{ margin: '5px 0' }} />
                            <GridContainer spacing={2} justify="center">
                                <GridItem xs={12} sm={12} md={4}>
                                    <Button color="info" fullWidth onClick={handleGetStatusLink}>
                                        Consultar Status
                                    </Button>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                    <Button 
                                        color="primary"
                                        fullWidth 
                                        onClick={handleLancarPagamento}>
                                        {t('button.post_payment')}
                                    </Button>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                    <Button fullWidth onClick={handleGerarOutroLink}>
                                        Gerar outro link
                                    </Button>
                                </GridItem>
                            </GridContainer>
                            <hr style={{ margin: '10px 0' }} />
                        </div>
                    ) : (
                        <>
                            <form onSubmit={handleSubmit(onSubmit)} style={{ padding: '5px 0 0' }}>
                                <hr style={{ margin: '0 0 30px 0' }} />
                                <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <div style={{ textAlign: 'right' }}>
                                            {t('label.value')} *
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            defaultValue=""
                                            name="valor"
                                            InputProps={{ inputComponent: MaskMoney }}
                                            inputRef={register({ required: true })}
                                            error={errors.valor ? true : false}
                                        />
                                        <FormHelperText>
                                            {errors.valor && <span className="obg">{t('label.required')}</span>}
                                        </FormHelperText>
                                    </GridItem>
                                </GridContainer>
                                {
                                    habilitaGerarLinkPagamento ? (
                                        <GridContainer className={classes.containerin}>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <center>
                                                    <Button type="submit" color="primary" >
                                                        {t('button.generate_payment_link')}
                                                    </Button>
                                                    {LoadingForm && <div style={{ marginTop: '10px' }}><CircularProgress /></div>}
                                                </center>
                                            </GridItem>
                                        </GridContainer>
                                    )
                                    : (
                                        <>
                                            <hr style={{ margin: '30px 0' }} />
                                            <center>
                                                <GridContainer className={classes.containerin}>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <div className='alertErrorEx' style={{ margin: '0' }}>
                                                        {
                                                            exiteLinkPagamento ? (
                                                                <p>
                                                                    Só é possível criar um Link de Pagamento por venda.
                                                                </p>
                                                            ) : (
                                                                <p>
                                                                    Para criar um Link de Pagamento, ele deve ser a primeira forma a ser adicionada aos Pagamentos Realizados.
                                                                </p>
                                                            )
                                                        }
                                                        </div>
                                                    </GridItem>
                                                </GridContainer>
                                            </center>
                                        </>
                                    )
                                }
                                <hr style={{ margin: '30px 0' }} />
                            </form>
                        </>
                    )
            }
        </div>
    )
}